import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import HttpService from '../../helpers/httpServices';
import { Postdata } from '../../helpers/api.service';
import { message } from '../../redux/actions/toastActions';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import Error403Page from '../ErrorPage';

const ViewSchool = () => {
    const [schoolData, setSchoolData] = useState(null);
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const params = useParams();
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    const isAccessible = role == "admin" || permissions && permissions?.includes('view_School') || false;

    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.admin_school_show, { id: params.id }).then((res) => {
            if (res.status === 200) {
                setSchoolData(res.data);
            } else {
                dispatch(message(res.message));
            }
            setLoader(false);
        });
    };

    useEffect(() => {
        fetchData();
    }, []);
    if (!isAccessible) {
        return (
            <>
                <Error403Page />
            </>
        );
    }

    if (loader) {
        return (
            <div className="flex items-center justify-center h-screen text-gray-600">
                Loading details...
            </div>
        );
    }

    if (!schoolData) {
        return (
            <div className="flex items-center justify-center h-screen text-red-500">
                No data found.
            </div>
        );
    }

    const fieldClass =
        "p-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-800 font-medium";

    return (
        <div className="p-6 space-y-6">
            <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-xl p-8">
                <h2 className="text-2xl font-bold mb-6 text-gray-800 border-b pb-3">
                    School Details
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-500">
                            First Name
                        </label>
                        <div className={fieldClass}>{schoolData.first_name}</div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-500">
                            Last Name
                        </label>
                        <div className={fieldClass}>{schoolData.last_name}</div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-500">
                            Username
                        </label>
                        <div className={fieldClass}>{schoolData.username}</div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-500">
                            School Name
                        </label>
                        <div className={fieldClass}>{schoolData.name}</div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-500">
                            Email
                        </label>
                        <div className={fieldClass}>{schoolData.email}</div>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-500">
                            Mobile Number
                        </label>
                        <div className={fieldClass}>{schoolData.mobile_number}</div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-500">
                            Sub-Domain
                        </label>
                        <div className={fieldClass}>{schoolData.subdomain}</div>
                    </div>

                    <div className="md:col-span-2">
                        <label className="block text-sm font-medium text-gray-500">
                            Terms & Conditions Agreement
                        </label>
                        <div
                            className={`${fieldClass} flex items-center gap-2 ${schoolData.isAgreeTC ? "text-green-600" : "text-red-600"
                                }`}
                        >
                            {schoolData.isAgreeTC ? "✔ Agreed" : "✘ Not Agreed"}
                        </div>
                    </div>
                </div>

                <div className="flex justify-end mt-8">
                    <button
                        onClick={() => window.history.back()}
                        className="px-6 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold"
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ViewSchool